import React from "react";
import "./Tabs.css";
import { useState } from "react";


export default function Tabs() {

    const tabs = [
  {
    id: "motor",
    title: "Motor",
    desc: "Isparta oto ekspertiz merkezimizde motor testi, aracınızın kalbini en ince detayına kadar inceler. Kompresyon ölçümleri, yağ kaçak kontrolleri ve performans analizleriyle motorun mevcut durumu net bir şekilde raporlanır. Uzman ekiplerimiz sayesinde Isparta ekspertiz hizmetimizle aracınızın motor sağlığını güvenle öğrenebilirsiniz.",
    img: "/Assets/tabs-engine.png", 
  },
  {
    id: "fren",
    title: "Fren",
    desc: "Fren sistemi, sürüş güvenliğinin temelidir. Isparta oto ekspertiz merkezimizde fren testleri özel cihazlarla yapılır. Pedal sertliği, balata durumu ve fren mesafesi ölçülerek aracınızın fren performansı detaylı bir şekilde değerlendirilir. Isparta ekspertiz raporlarımız, güvenli sürüş için en doğru verileri sunar.",
    img: "/Assets/brake-disc.png",
  },
  {
    id: "elektronik",
    title: "Elektronik",
    desc: "Günümüz araçlarının büyük kısmı elektronik sistemlere dayanır. Isparta oto ekspertiz hizmetimizde araç beyni (ECU) dahil olmak üzere tüm elektronik donanım kontrol edilir. Arıza kodları okunur, sensörler ve elektrik bağlantıları test edilir. Isparta ekspertiz farkıyla elektronik sistemlerinizin sorunsuz çalıştığından emin olun.",
    img: "/Assets/electronics.png",
  },
  {
    id: "kaporta",
    title: "Kaporta",
    desc: "Kaporta ekspertizi, aracın geçmişte bir kazaya karışıp karışmadığını ortaya çıkarır. Isparta oto ekspertiz merkezimizde boya kalınlığı ölçer cihazlarla yapılan detaylı analizle değişen, boyanan veya macunlu parçalar tespit edilir. Isparta ekspertiz raporlarımızla aracınızın dış yapısı hakkında net bilgilere ulaşabilirsiniz.",
    img: "/Assets/kaporta.png",
  },
  {
    id: "Mekanik",
    title: "Mekanik",
    desc: "Mekanik ekspertiz, aracın hareketli aksamlarını kapsar. Isparta oto ekspertiz ekibimiz süspansiyon, direksiyon, şanzıman ve yürür aksam kontrollerini titizlikle gerçekleştirir. Mekanik testlerle birlikte araç performansını etkileyen tüm parçalar değerlendirilir. Güvenilir Isparta ekspertiz raporumuzla aracınızın genel durumu elinizin altında.",
    img: "/Assets/mekanik.png",
  },
];

   
    const [activeTab, setActiveTab] = useState(null);
  const [activeImage, setActiveImage] = useState("/Assets/tabs-car.png");

  const handleClick = (tab) => {
    if (activeTab === tab.id) {
      setActiveTab(null);
      setActiveImage("/Assets/tabs-car.png");
    } else {
      setActiveTab(tab.id);
      setActiveImage(tab.img);
    }
  };

    return (
        <div className={`tabs-container ${activeTab ? 'has-active' : ''}`}>
            <div className="tab-img-container">
                 <img
                src={activeImage}
                alt="car"
                 className="tab-img"
                 />
            </div>
            <div className="tabs-blocks">
                {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => handleClick(tab)}
            
          >
            <div className="tab-header">
              <span
                className={`tab-plus ${
                  activeTab === tab.id ? "rotate-45" : ""
                }`}
              >
                {activeTab === tab.id ? "−" : "+"}
              </span>
              <span className="font-semibold">{tab.title}</span>
            </div>

            {activeTab === tab.id && (
              <p className="tab-desc">
                {tab.desc}
              </p>
            )}
          </div>
        ))}
            </div>
        </div>
    );
}